export const panelClassName =
  'bg-[var(--color-surface)] rounded-[8px] p-4 flex flex-col gap-3 border border-[var(--color-border)] shadow-sm';

export const inputClassName =
  'px-3 py-2 rounded-[6px] border border-[var(--color-border)] bg-[var(--color-surface-muted)] text-[var(--color-text)] placeholder:text-[var(--color-text-muted)] focus:outline-none focus:border-[var(--color-fixed-accent)]';

export const primaryButtonClassName =
  'px-3 py-2 rounded-[6px] bg-[var(--color-fixed-accent)] text-[var(--color-fixed-white)] hover:bg-[var(--color-link)] disabled:bg-[var(--color-disabled-background)] disabled:text-[var(--color-disabled-text)] disabled:cursor-not-allowed';

export const compactPrimaryButtonClassName =
  'px-3 py-1 rounded-[6px] bg-[var(--color-fixed-accent)] text-[var(--color-fixed-white)] hover:bg-[var(--color-link)] disabled:bg-[var(--color-disabled-background)] disabled:text-[var(--color-disabled-text)] disabled:cursor-not-allowed';

export const secondaryButtonClassName =
  'px-3 py-2 rounded-[6px] border border-[var(--color-border)] bg-[var(--color-surface-muted)] text-[var(--color-text)] hover:bg-[var(--color-tint)] disabled:bg-[var(--color-disabled-background)] disabled:text-[var(--color-disabled-text)] disabled:cursor-not-allowed';

export const compactSecondaryButtonClassName =
  'px-3 py-1 rounded-[6px] border border-[var(--color-border)] bg-[var(--color-surface-muted)] text-[var(--color-text)] hover:bg-[var(--color-tint)] disabled:bg-[var(--color-disabled-background)] disabled:text-[var(--color-disabled-text)] disabled:cursor-not-allowed';

export const segmentedButtonClassName = (isActive: boolean): string =>
  isActive
    ? 'px-3 py-1 rounded-[6px] bg-[var(--color-fixed-accent)] text-[var(--color-fixed-white)]'
    : compactSecondaryButtonClassName;
